import React, { useEffect, useRef, useState } from 'react'
import { TabItem } from '../../models/TabItem';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as LeftArrow } from '../../assets/svg/left-chevron.svg';
import { ReactComponent as RightArrow } from '../../assets/svg/right-chevron.svg';

interface Props {
    styles: any;
    path?: string;
    tabItems: TabItem[];
    selectedTab: string;
    getSelectedTab?(selectedTabs: string): void;
    enableScrollArrows?: boolean;
}

export const Tabs: React.FC<Props> = (props) => {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState<string>(props.selectedTab);
    const [tabContent, setTabContent] = useState();
    const styles = props.styles;
    const linkWrapperRef = useRef<HTMLDivElement>(null);
    const [showArrows, setShowArrows] = useState<boolean>(false);

    useEffect(() => {
        changeTab(props.selectedTab);
    }, [props.selectedTab]);

    useEffect(() => {
        if (!props.enableScrollArrows) {
            setShowArrows(false);
            return;
        }
        const el = linkWrapperRef.current;
        if (el) setShowArrows(el.scrollWidth > el.clientWidth);
    }, [props.tabItems, props.enableScrollArrows]);

    const scrollTabs = (dir: number) => linkWrapperRef.current?.scrollBy({ left: dir * 120, behavior: 'smooth' });

    const onTabChange = (tabValue: string) => {
        if(props.path) {
            navigate(props.path + tabValue + "?noScroll=true");
        } else {
            changeTab(tabValue);
        }
        if(props.getSelectedTab) {
            props.getSelectedTab(tabValue);
        }
    }

    const changeTab = (tabValue: string) => {
        let selectedTab: TabItem = props.tabItems.filter(t => t.value === tabValue)[0];
        if(selectedTab.component) {
            setSelectedTab(tabValue);
            setTabContent(props.tabItems.filter(t => t.value === tabValue)[0].component);
        }        
    }

    return (
        <div style={styles.container}>
            <div style={props.enableScrollArrows && styles.tabsWrapper}>
                {showArrows && 
                    <button onClick={() => scrollTabs(-1)}>
                        <LeftArrow style={styles.arrowIcon} />
                    </button>
                }
                <div ref={linkWrapperRef} style={styles.linkWrapper} className={"disableScrollBar"}>
                    {props.tabItems.map((tabItem, index) =>
                        <div
                            key={index}
                            style={{ ...styles.link, ...(selectedTab === tabItem.value && styles.link.active), ...tabItem.styles }}
                            onClick={() => onTabChange(tabItem.value)}>{tabItem.label}
                        </div>
                    )}
                </div>
                {showArrows && 
                    <button onClick={() => scrollTabs(1)}>
                        <RightArrow style={styles.arrowIcon} />
                    </button>
                }
            </div>
            <div style={styles.contentWrapper}>                
                {tabContent}
            </div>
        </div>
    )
}